import React, { useState } from 'react';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import DragAndDrop from './DragAndDrop';
import FacialScanPreview from './FacialScanPreview';
import style from './NewPatientPhotos.module.css';
import photoStyle from './NewPatientPhoto.module.css';
import { getWebAbsPath } from '../../../util/path';

/**
 * Checks whether the uploaded facial scan has a supported extension.
 */
const isSupportedFacialScan = (file) => ['ply', 'obj'].includes(file?.name?.split('.').pop().toLowerCase());

/**
 * Provides file selection, drag-and-drop, and preview for a facial scan.
 */
const FacialScanUploader = ({ facialScan, handleChange, mode }) => {
    const [error, setError] = useState('');
    const scanSource = facialScan?.dataURL || facialScan?.data;

    /** Handles a file selected from either the picker or drop zone. */
    const handleFile = (value) => {
        const file = value?.length ? value[0] : value;
        setError('');
        handleChange(file);
    };

    /** Removes the selected facial scan. */
    const removeFile = () => {
        setError('');
        handleChange('remove');
    };

    return (
        <div>
            <DragAndDrop handleDrop={handleFile} disabled={mode === 'view'}>
                <div className={`${photoStyle.card} ${style.facialScanStatusCard}`}>
                    {mode !== 'view' && (
                        <label className={style.facialScanPlus}>
                            +
                            <input
                                className={style.facialScanUploadInput}
                                type="file"
                                accept=".ply,.obj"
                                onChange={(event) => handleFile(event.target.files[0])}
                            />
                        </label>
                    )}
                    {scanSource ? (
                        <>
                            <div className={photoStyle.cardImage}>
                                <img
                                    className={style.facialScanFace}
                                    src={getWebAbsPath('/img/uploaded.png')}
                                    alt="Frontal Extraoral Facial"
                                />
                                {/* <FacialScanPreview source={getWebAbsPath('/img/uploaded.png')} fileName={facialScan?.name} /> */}
                            </div>
                            {mode !== 'view' && (
                                <button className={style.facialScanRemove} onClick={removeFile} type="button">
                                    <DeleteOutlinedIcon />
                                </button>
                            )}
                        </>
                    ) : (
                        <div className={photoStyle.cardImage}>
                            <img
                                className={style.facialScanFace}
                                src={getWebAbsPath('/img/3D scan.png')}
                                alt="Frontal Extraoral Facial"
                            />
                            <span className={style.facialScanStatusText}>Upload 3D facial scan</span>
                        </div>
                    )}
                </div>
            </DragAndDrop>
            {error && <p className={style.facialScanError}>{error}</p>}
            <p className={style.facialScanHint}>
                Browse or drag &amp; drop a .PLY / .OBJ exported from Clone Dental Pro, Metismile or another 3D-capture
                app.
            </p>
        </div>
    );
};

export default FacialScanUploader;
